import {
  FormProvider,
  SubmitHandler,
  useForm,
  useFormContext,
} from 'react-hook-form';
import MainLayout from '@/common/components/layouts/MainLayout.tsx';
import useSignUpRequest from '@/modules/Auth/hooks/useSignUpRequest.ts';
import { Flex } from 'styled-system/jsx';
import TitleDescription from '@/common/components/base/typography/TitleDescription.tsx';
import TextInput from '@/common/components/base/input/textInput/TextInput.tsx';
import { PERSIAN_LATTER_RULE } from '@/common/components/base/input/textInput/textInput.rules.ts';
import ProvinceAndCounty from '@/common/components/customInputs/ProvinceAndCounty.tsx';
import MobileInput from '@/common/components/base/input/mobileInput/MobileInput.tsx';
import FileInput from '@/common/components/base/input/fileInput/FileInput.tsx';
import { SignUpFormDataType } from '@/modules/Auth/types/formDataType/signUpFormData.type.ts';
import RegisteredPendingModal from '@/modules/Auth/components/modals/RegisteredPendingModal.tsx';
import useModal from '@/common/hooks/useModal.ts';
import useToast from '@/common/store/alert/useToast.ts';
import AlreadyRegisteredModal from '@/modules/Auth/components/modals/AlreadyRegisteredModal.tsx';
import LoadingButton from '@/common/components/base/button/loadingButton.tsx';
import RegisterSuccessfulModal from '@/modules/Auth/components/modals/RegisterSuccessfulModal.tsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { fileSizeValidation } from '@/common/components/base/input/fileInput/fileInput.rules';

export default function () {
  const methods = useForm();
  return (
    <MainLayout
      hasBottomPadding
      header="titleHeader"
      title="فرم درخواست همکاری"
    >
      <FormProvider {...methods}>
        <Register />
      </FormProvider>
    </MainLayout>
  );
}
const Register = () => {
  const { handleSubmit } = useFormContext<SignUpFormDataType>();
  const { mutate, isPending, isSuccess } = useSignUpRequest();
  const showAlert = useToast((state) => state.showAlert);
  const {
    closeModal: closeRegisteredPendingModal,
    openModal: openRegisteredPendingModal,
    open: isRegisteredPendingModalOpen,
  } = useModal();

  const {
    closeModal: closeAlreadyRegisteredModal,
    openModal: openAlreadyRegisteredModal,
    open: isAlreadyRegisteredModalOpen,
  } = useModal();

  const generateFormData = (data: SignUpFormDataType) => {
    const formData = new FormData();
    formData.append('first_name', data.first_name);
    formData.append('last_name', data.last_name);
    formData.append('province', String(data.province.value));
    formData.append('county', String(data.county.value));
    formData.append('phone_number', data.phone_number);
    formData.append('resume', data.resume);
    return formData;
  };
  const handleMutateErrors = (error?: string, faError?: string | null) => {
    if (error === 'adjuster_already_exists') {
      openAlreadyRegisteredModal();
    } else if (error === 'adjuster_signup_already_exists') {
      openRegisteredPendingModal();
    } else if (faError) {
      showAlert({ description: faError, type: 'error' });
    }
  };
  const onSubmit: SubmitHandler<SignUpFormDataType> = (data) => {
    const formData = generateFormData(data);
    mutate(formData as unknown as SignUpFormDataType, {
      onError: (error) => {
        handleMutateErrors(error.code, error.fa_details);
      },
    });
  };

  return (
    <>
      <Flex flexDirection="column">
        <TitleDescription color="black-1" textStyle="b1" my={'15px'}>
          فرم زیر را جهت تکمیل تقاضای خود پر کنید
        </TitleDescription>
        <form onSubmit={handleSubmit(onSubmit)}>
          <TextInput
            placeholder="نام را وارد کنید"
            rules={{
              required: 'وارد کردن نام اجباری است',
              ...PERSIAN_LATTER_RULE,
            }}
            name="first_name"
            label="نام"
          />
          <TextInput
            placeholder="نام خانوادگی را وارد کنید"
            rules={{
              required: 'وارد کردن نام خانوادگی اجباری است',
              ...PERSIAN_LATTER_RULE,
            }}
            name="last_name"
            label="نام خانوادگی"
          />
          <ProvinceAndCounty />
          <MobileInput
            rules={{ required: 'وارد کردن شماره تلفن اجباری است' }}
            name="phone_number"
          />
          <FileInput
            rules={{
              required: 'آپلود رزومه اجباری است',
              validate: {
                fileSize: (file: File) => fileSizeValidation(file, 10),
              },
            }}
            name="resume"
            label="آپلود رزومه"
          />
          <Typography textStyle="b4" color="black-3">
            قالب فایل PDF و حجم فایل کمتر از 10 مگابایت باشد.
          </Typography>
          <LoadingButton loading={isPending} fullWidth mt={33}>
            ثبت اطلاعات
          </LoadingButton>
        </form>
      </Flex>
      <RegisteredPendingModal
        closeModal={closeRegisteredPendingModal}
        open={isRegisteredPendingModalOpen}
      />
      <AlreadyRegisteredModal
        open={isAlreadyRegisteredModalOpen}
        closeModal={closeAlreadyRegisteredModal}
      />
      <RegisterSuccessfulModal open={isSuccess} />
    </>
  );
};
